import { gql } from "@apollo/client";

export const UPDATE_INVOICE_DETAILS = gql`
  mutation updateInvoiceDetails($input: UpdateInvoiceDetailsInput!) {
    invoice {
      updateInvoiceDetails(input: $input) {
        success
      }
    }
  }
`;
